import React from 'react';

const Button = ({
  label,
  type = 'button',
  onClick,
  className = 'btn btn-primary',
  disabled = false,
  icon = null,
}) => {
  return (
    <button
      type={type}
      className={`${className} d-inline-flex align-items-center`}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && <i className={`${icon} me-2`}></i>}
      {label}
    </button>
  );
};

export default Button;
